import styled from 'styled-components'

const AssistButtons = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    bottom: 6px;
    right: 10px;
    display: flex;
    &:not(:focus-within) {
        opacity: ${(p) => (p.$isVisible ? 1 : 0)};
        pointer-events: ${(p) => (p.$isVisible ? 'auto' : 'none')};
    }
`

export default AssistButtons
